import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogClose, MatDialogActions, MatDialogTitle, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { SharedModule } from '../shared.module';

@Component({
  selector: 'app-session-expire',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    MatDialogClose,
    MatDialogActions,
    MatDialogTitle,
    MatDialogContent
  ],
  templateUrl: './session-expire.component.html',
  styleUrl: './session-expire.component.scss'
})
export class SessionExpireComponent {
    private dialogRef = inject(MatDialogRef<SessionExpireComponent>); // ✅ Angular 18 style

loginAgain(): void {
    this.dialogRef.close(); // triggers afterClosed in interceptor
  }
}
